import { render, staticRenderFns } from "./hotelReservations.vue?vue&type=template&id=5037f2fc&"
import script from "./hotelReservations.vue?vue&type=script&lang=js&"
export * from "./hotelReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports